<!-- Add Deposits Modal  -->

<form [formGroup]="depositOccurenceForm" (ngSubmit)="SaveDeposit()">
  <!-- Modal Header -->
  <div
    class="p-3 flex align-items-center justify-content-between surface-0 sticky left-0 bottom-0 w-full z-1 border-bottom-1 border-300"
  >
    <h2 class="mb-0 text-sm">{{ 'DEPOSIT.NAME' | depositTranslate }}</h2>
    <button
      type="button"
      class="fa fa-times text-xl text-600 cursor-pointer border-none bg-transparent p-0"
      (click)="closeDialog()"
      aria-label="close-dialog-button"
      data-testid="close-dialog-button"
    ></button>
  </div>
  <!-- Modal Header -->

  <!-- Modal Content -->
  <div class="p-3 surface-100">
    <!-- Tabs for Desktop -->
    <div
      class="p-buttonset hidden md:block"
      data-testid="deposit-tabs-container"
    >
      @for (occurence of occurenctType; track occurence) {
        <p-button
          type="button"
          styleClass="text-xs white-space-nowrap"
          (click)="SelectedOccurenceTypeFormControl = occurence"
          (keydown.enter)="SelectedOccurenceTypeFormControl = occurence"
          [label]="('DEPOSIT.' + occurence.value) | depositTranslate"
          [outlined]="
            occurence.value !== SelectedOccurenceTypeFormControl.value.value
          "
          severity="primary"
          [attr.aria-label]="'deposit-tab-' + occurence.value"
          [attr.data-testid]="'deposit-tab-' + occurence.value + '-button'"
        />
      }
      @if (
        SelectedOccurenceTypeFormControl?.touched &&
        SelectedOccurenceTypeFormControl?.invalid
      ) {
        <app-error-msg
          [errors]="SelectedOccurenceTypeFormControl?.errors"
          [fieldLabel]="'DEPOSIT.OCCURENCE_TYPE' | depositTranslate"
        />
      }
    </div>
    <!-- Tabs for Desktop -->

    <!-- Selectbox for Mobile -->
    <div class="md:hidden mt-2" data-testid="mobile-occurrence-type-container">
      <p-select
        [options]="occurenctType"
        optionLabel="value"
        formControlName="occurence_type"
        filterBy="value"
        styleClass="w-full text-sm"
        aria-label="occurrence-type-dropdown"
        data-testid="occurrence-type-dropdown"
      >
        <ng-template pTemplate="selectedItem">
          @if (SelectedOccurenceTypeFormControl.value) {
            <div class="text-sm">
              {{ SelectedOccurenceTypeFormControl.value.value }}
            </div>
          }
        </ng-template>
        <ng-template let-deposit pTemplate="item">
          <div class="text-sm">{{ deposit.value }}</div>
        </ng-template>
      </p-select>
      @if (
        SelectedOccurenceTypeFormControl?.touched &&
        SelectedOccurenceTypeFormControl?.invalid
      ) {
        <app-error-msg
          [errors]="SelectedOccurenceTypeFormControl?.errors"
          [fieldLabel]="'DEPOSIT.OCCURENCE_TYPE' | depositTranslate"
        />
      }
    </div>
    <!-- Selectbox for Mobile -->

    <!-- Deposit Type 1 -->
    <div class="mt-3">
      <div class="flex align-items-center text-600">
        <i class="fa fa-info-circle mr-2"></i>
        <p class="text-xs mb-0">
          {{
            ('DEPOSIT.INFO.' + SelectedOccurenceTypeFormControl.value.value)
              | depositTranslate
          }}
        </p>
      </div>

      @if (
        SelectedOccurenceTypeFormControl.value.value !==
          GetOccurenceType.ApplyManually &&
        SelectedOccurenceTypeFormControl.value.value.toString() !==
          GetOccurenceType[GetOccurenceType.ApplyManually]
      ) {
        <div class="mt-4 pt-2" data-testid="occurrence-selection-container">
          <label
            for="occurrence-dropdown"
            class="font-medium text-700 text-xs mb-2 block uppercase"
            >{{ 'DEPOSIT.OCCURRENCE' | depositTranslate }}</label
          >
          <p-select
            [options]="occurences"
            optionLabel="key"
            filterBy="key"
            optionDisabled="selected"
            formControlName="occurence"
            styleClass="w-full text-sm"
            placeholder="Select..."
            aria-label="occurrence-dropdown"
            data-testid="occurrence-dropdown"
            inputId="occurrence-dropdown"
          >
            <ng-template pTemplate="selectedItem">
              @if (SelectedOccurenceFormControl.value) {
                <div class="text-sm">
                  {{ SelectedOccurenceFormControl.value.key }}
                </div>
              }
            </ng-template>
            <ng-template let-occurence pTemplate="item">
              <div class="text-sm">{{ occurence.key }}</div>
            </ng-template>
          </p-select>
          @if (
            SelectedOccurenceFormControl?.touched &&
            SelectedOccurenceFormControl?.invalid
          ) {
            <app-error-msg
              [errors]="SelectedOccurenceFormControl?.errors"
              [fieldLabel]="'DEPOSIT.OCCURRENCE' | depositTranslate"
            />
          }
        </div>
      }

      @if (
        SelectedOccurenceTypeFormControl.value.value ===
          GetOccurenceType.ApplyManually ||
        SelectedOccurenceTypeFormControl.value.value.toString() ===
          GetOccurenceType[GetOccurenceType.ApplyManually]
      ) {
        <div
          class="flex align-items-center mt-3 ml-3 pl-2"
          data-testid="manual-deposit-toggle-container"
        >
          <p-toggleSwitch
            formControlName="add_occurence"
            [ngClass]="{
              'ng-invalid ng-dirty':
                AddOccurenceFormControl.invalid &&
                AddOccurenceFormControl.touched,
            }"
            aria-label="add-occurrence-toggle"
            data-testid="add-occurrence-toggle"
          />
          <p class="text-sm mb-0 ml-3 -mt-1">
            {{ 'common.BUTTONS.BTN_ADD_DEPOSIT' | depositTranslate }}
          </p>
        </div>
      }
    </div>
    <!-- Deposit Type 1 -->
  </div>
  <!-- Modal Content -->

  <!-- Modal Footer -->
  <div
    class="p-3 flex align-items-center justify-content-between surface-0 sticky left-0 bottom-0 w-full z-1 border-top-1 border-300"
    data-testid="modal-footer-container"
  >
    <p-button
      [label]="'ADMIN.COMMON.CANCEL' | translate"
      styleClass="p-button-link text-sm"
      (click)="closeDialog()"
      (keydown.enter)="closeDialog()"
      aria-label="cancel-button"
      data-testid="cancel-button"
    />
    <p-button
      styleClass="text-sm"
      type="submit"
      [disabled]="!depositOccurenceForm.valid || !isValidDeposit()"
      [label]="'common.BUTTONS.BUTTON-TEXT-SAVE' | translate"
      aria-label="save-deposit-button"
      data-testid="save-deposit-button"
    />
  </div>
  <!-- Modal Footer -->
</form>

<!-- Add Deposits Modal -->
